(function () {
  'use strict';

  /*
  ============================================================
  CARD HEIGHT ALIGNMENT
  ============================================================
  */

  function alignInnerCards() {
    const sections = document.querySelectorAll(
      '.custom-card-layout-inner'
    );

    if (!sections.length) return;

    sections.forEach(function (section) {
      const cards = section.querySelectorAll(
        '.custom-card-item-inner'
      );

      if (!cards.length) return;

      /*
       * Reset heights before recalculating.
       */
      cards.forEach(function (card) {
        const heading = card.querySelector(
          '.card-heading-inner'
        );

        const subtitle = card.querySelector(
          '.card-subheading-inner'
        );

        if (heading) {
          heading.style.height = 'auto';
        }

        if (subtitle) {
          subtitle.style.height = 'auto';
        }
      });


      /*
       * Group cards according to their visual row.
       */
      const rows = {};

      cards.forEach(function (card) {
        const top = card.offsetTop;

        if (!rows[top]) {
          rows[top] = [];
        }

        rows[top].push(card);
      });


      /*
       * Find maximum heading/subtitle height
       * for every row.
       */
      Object.values(rows).forEach(function (rowCards) {
        let maxHeadingHeight = 0;
        let maxSubtitleHeight = 0;

        rowCards.forEach(function (card) {
          const heading = card.querySelector(
            '.card-heading-inner'
          );

          const subtitle = card.querySelector(
            '.card-subheading-inner'
          );

          if (
            heading &&
            heading.offsetHeight > maxHeadingHeight
          ) {
            maxHeadingHeight = heading.offsetHeight;
          }

          if (
            subtitle &&
            subtitle.offsetHeight > maxSubtitleHeight
          ) {
            maxSubtitleHeight = subtitle.offsetHeight;
          }
        });


        /*
         * Apply calculated height to cards
         * within that row.
         */
        rowCards.forEach(function (card) {
          const heading = card.querySelector(
            '.card-heading-inner'
          );

          const subtitle = card.querySelector(
            '.card-subheading-inner'
          );

          if (heading) {
            heading.style.height =
              maxHeadingHeight + 'px';
          }

          if (subtitle) {
            subtitle.style.height =
              maxSubtitleHeight + 'px';
          }
        });
      });
    });
  }


  /*
  ============================================================
  PDF DOWNLOAD
  ============================================================
  */

  async function downloadPdf(button) {
    const pdfUrl = button.href;

    if (!pdfUrl) return;

    /*
     * Prevent user clicking multiple times
     * while download is processing.
     */
    if (button.dataset.downloading === 'true') {
      return;
    }

    button.dataset.downloading = 'true';
    button.classList.add('is-downloading');

    try {
      const response = await fetch(pdfUrl);

      if (!response.ok) {
        throw new Error(
          'PDF download failed. Status: ' +
          response.status
        );
      }


      /*
       * Convert PDF response into Blob.
       */
      const blob = await response.blob();


      /*
       * Generate temporary browser URL.
       */
      const blobUrl = URL.createObjectURL(blob);


      /*
       * Create temporary download link.
       */
      const downloadLink =
        document.createElement('a');

      downloadLink.href = blobUrl;

      downloadLink.download =
        getPdfFilename(pdfUrl);

      downloadLink.style.display = 'none';

      document.body.appendChild(downloadLink);


      /*
       * Force browser download.
       */
      downloadLink.click();


      /*
       * Clean temporary element.
       */
      downloadLink.remove();


      /*
       * Clean Blob URL after browser
       * has had time to start download.
       */
      setTimeout(function () {
        URL.revokeObjectURL(blobUrl);
      }, 1000);

    } catch (error) {
      console.error(
        'PDF download failed:',
        error
      );

      /*
       * Fallback.
       *
       * If Shopify CDN/browser prevents fetch,
       * use normal PDF URL.
       */
      window.location.href = pdfUrl;

    } finally {
      button.dataset.downloading = 'false';

      button.classList.remove(
        'is-downloading'
      );
    }
  }


  /*
   * Get filename from Shopify CDN URL.
   *
   * Example:
   *
   * https://cdn.shopify.com/.../
   * 35_x_24mm_Artwork_Template.pdf?v=123
   *
   * becomes:
   *
   * 35_x_24mm_Artwork_Template.pdf
   */
  function getPdfFilename(url) {
    try {
      const parsedUrl = new URL(
        url,
        window.location.origin
      );

      let filename =
        parsedUrl.pathname.split('/').pop();

      if (!filename) {
        filename = 'download.pdf';
      }


      filename =
        decodeURIComponent(filename);


      /*
       * Remove characters that are not
       * safe for filenames.
       */
      filename = filename.replace(
        /[<>:"/\\|?*]/g,
        '-'
      );


      /*
       * Make sure filename has .pdf
       */
      if (
        !filename
          .toLowerCase()
          .endsWith('.pdf')
      ) {
        filename += '.pdf';
      }


      return filename;

    } catch (error) {
      return 'download.pdf';
    }
  }


  /*
  ============================================================
  GLOBAL CLICK LISTENER
  ============================================================
  */

  document.addEventListener(
    'click',
    function (event) {

      const button = event.target.closest(
        '[data-pdf-download]'
      );

      if (!button) return;


      /*
       * Stop browser opening PDF normally.
       */
      event.preventDefault();


      downloadPdf(button);
    }
  );


  /*
  ============================================================
  EVENTS
  ============================================================
  */

  window.addEventListener(
    'load',
    alignInnerCards
  );


  /*
   * Recalculate after browser resize.
   */
  window.addEventListener(
    'resize',
    alignInnerCards
  );


  /*
   * Shopify Theme Editor:
   * section added/reloaded.
   */
  document.addEventListener(
    'shopify:section:load',
    alignInnerCards
  );

})();